/* eslint-disable ember/no-computed-properties-in-native-classes */
// Extends From
import Controller from '@ember/controller';
// Ember Imports
import { tracked } from '@glimmer/tracking';
import { get, set, action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
// Internal Imports
import { filterValue } from '@linc-technologies/linced-common/utils/filtering';
import DataType from '@linc-technologies/linced-common/enums/data-type';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

export default class IndexController extends Controller {
  Jurisdiction = Jurisdiction;

  @service
  session;

  @tracked
  filters = [];

  @computed('model.medications.[]')
  get currentMedications() {
    return this.model.medications.filter((medication) => !medication.deleted);
  }

  @computed('currentMedications.[]', 'filters.@each.{field,value}')
  get filteredMedications() {
    if (isEmpty(this.filters)) {
      // No filters - just return the data.
      return this.currentMedications;
    }

    // Determine datatypes for any specified filters.
    let filters = this.filters.map((filter) => {
      return {
        key: filter.field,
        dataType: DataType.STRING,
        value: filter.value,
      };
    });

    // Apply all filters to each row in one hit, to avoid iterating over a
    // (potentially) large dataset multiple times.
    return this.currentMedications.filter((row) => {
      return filters.every((filter) => {
        // Generic filter processing.
        return filterValue(
          get(row, filter.key) ?? '',
          filter.dataType,
          filter.value,
        );
      });
    });
  }

  @action
  filter(field, value) {
    let filter = findBy(this.filters, 'field', field);
    if (isEmpty(filter)) {
      // No existing filter on this field; add it.
      this.filters = [...this.filters, { field, value }];
      return;
    }

    if (isEmpty(value)) {
      // Filter has been cleared; remove it.
      this.filters = this.filters.filter((f) => f !== filter);
    } else {
      // Existing filter has been changed; update it.
      set(filter, 'value', value);
    }
  }
}
